import {
  Flex,
  Image,
  Skeleton,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"

import { useBranding } from "@/hooks/useBranding"
import UserMenu from "./UserMenu"

function Navbar() {
  const display = useBreakpointValue({ base: "none", md: "flex" })
  const { display_name, logo_url, isLoading } = useBranding()

  return (
    <Flex
      display={display}
      justify="space-between"
      position="sticky"
      color="white"
      align="center"
      bg="bg.muted"
      w="100%"
      top={0}
      p={2}
    >
      <Link to="/">
        {isLoading ? (
          <Skeleton h="36px" w="160px" rounded="md" mx={2} />
        ) : (
          <Flex align="center" gap={2} px={2}>
            <Image
              src={logo_url}
              alt={display_name}
              h="36px"
              objectFit="contain"
            />
            <Text fontWeight="semibold" fontSize="md" color="fg">
              {display_name}
            </Text>
          </Flex>
        )}
      </Link>
      <Flex gap={4} alignItems="center">
        <UserMenu />
      </Flex>
    </Flex>
  )
}

export default Navbar
